import { render } from "./SiteNav.vue?vue&type=template&id=2e3e7c4e"
import script from "./SiteNav.vue?vue&type=script&lang=js"
export * from "./SiteNav.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__